var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIReferenceCustom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69137 9.99755L2.42563 10.3218C1.97582 10.4369 1.56262 10.0289 1.67769 9.5739L2.00197 8.30816C2.06473 8.0571 2.19549 7.82697 2.37855 7.6439L7.16954 2.85815L9.14137 4.82999L4.35562 9.62097C4.17256 9.80403 3.94242 9.93479 3.69137 9.99755Z",
    stroke: "#C4C8CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31037 1.97028L10.0279 2.68777C10.3755 3.03542 10.3755 3.59758 10.0279 3.94523L9.14394 4.82914L7.16899 2.8542L8.05291 1.97028C8.40056 1.62263 8.96272 1.62263 9.31037 1.97028Z",
    stroke: "#C4C8CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIReferenceCustom);
export default __webpack_public_path__ + "static/media/i_reference_custom.006b273d5a959b5a9e8fff2a67796b53.svg";
export { ForwardRef as ReactComponent };